import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Dialog } from '@material-ui/core'

import InputField from '@/Common/NewForm/InputField'
import Checkbox from '@/Common/NewForm/Checkbox'
import CloseButton from '@/Common/CloseButton'

import axios from "axios"
import { GetBaseUrl } from '@/utils/ConfigHelper'
import { mode } from "webconfig"

import TosDialog from './TosDialog'
import OneBtnDialog from '@/Common/OneBtnDialog/OneBtnDialog'

import i18n from '../../i18n'

import { Login, SetIsShowSignUpDialog, HistoryPush } from '../../Interface'
import { GetTrackingData, SetTrackingData } from '../../utils/TrackingData'

import './index.scss'

class LoginDialog extends Component {
    state = {}

    initState = () => {
        this.setState({
            isShowTosDialog: false,
            tosDialogContent: null,

            emailAlertBottomText: null,
            nicknameAlertBottomText: null,
            passwordAlertBottomText: null,
            isPasswordConfirmBottomAlert: false,
    
            email: "",
            nickname: "",
            password: "",
            passwordConfirm: "",
            code: "",
            recommender: sessionStorage.getItem('recommenderSession') ? sessionStorage.getItem('recommenderSession') : "",

            verifyStatus: 'none',

            isNoChildren: false,
            isTosAgree: false,
            isPrivacyAgree: false,
            isResaleAgree: false,
            isAiAgree: false,
            isUseInfoAgree: false,
            isMarketingAgree: false,
            isAccountPermanentAgree: false,
            isAgreeAll: false,

            isOneBtnDialogOpen: false,
            oneBtnDialogType: "verifyNumber"
        })
    }

    koCheckboxLabel = {
        label1: '이용약관 동의 (필수)',
        label2: '개인정보 수집 및 이용동의 (필수)',
        label3: '서비스 재판매 금지에 대한 동의 (필수)',
        label4: '선택정보 수집 및 이용동의 (선택)',
        label5: 'AI약관 동의 (필수)',
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open) this.initState()
    }

    handleClickOneBtnDialogClose = () => this.setState({ isOneBtnDialogOpen: false })

    handleChangeInput = e => this.setState({ [e.target.name]: e.target.value })
    handleChangeCheckbox = e => {
        if (!e.target.checked) this.setState({ isAgreeAll: false })
        this.setState({ [e.target.name]: e.target.checked }, () => {
            const {
                isAgreeAll,
                isNoChildren,
                isTosAgree,
                isPrivacyAgree,
                isResaleAgree,
                isAiAgree,
                isUseInfoAgree,
                isMarketingAgree,
                isAccountPermanentAgree
            } = this.state

            if (!isAgreeAll && isNoChildren && isTosAgree && isPrivacyAgree && isResaleAgree && isAiAgree && isUseInfoAgree && isMarketingAgree && isAccountPermanentAgree) {
                this.setState({ isAgreeAll: true })
            }
        })
    }

    handleBlurInput = async e => {
        try {
            const { name, value } = e.target
            switch (name) {
                case 'email':
                    {
                        let emailAlertBottomText = null
                        if (!this.validateEmail(value)) emailAlertBottomText = i18n.t("signup.enter.again.email")
                        else {
                            const { data: { isExist } } = await axios.get(`${GetBaseUrl()}/api/auth/is-exist-email?email=${value}`)
                            if (isExist) emailAlertBottomText = i18n.t("signup.enter.duplicated.email")
                        }
                        this.setState({ emailAlertBottomText })
                    }
                    break
    
                case 'nickname':
                    {
                        let nicknameAlertBottomText = null
                        if (!value || value.length === 0) nicknameAlertBottomText = i18n.t("signup.enter.check.nickname")
                        else {
                            const { data: { isExist } } = await axios.get(`${GetBaseUrl()}/api/auth/is-exist-nickname?nickname=${value}`)
                            if (isExist) nicknameAlertBottomText = i18n.t("signup.enter.duplicated.nickname")
                        }
                        this.setState({ nicknameAlertBottomText })
                    }
                    break
    
                case 'password':
                    {
                        let passwordAlertBottomText = null
                        if (!value || !(value.length >= 8 && value.length <= 32)) passwordAlertBottomText = i18n.t("signup.enter.check.password.length")
                        this.setState({ passwordAlertBottomText })
                    }
                    break
                
                default: break
            }
        }
        catch (e) {
            // NOTHING
        }
    }

    handleChangePasswordConfirm = e => {
        this.setState({ passwordConfirm: e.target.value }, () => {
            const { password, passwordConfirm } = this.state
            this.setState({ isPasswordConfirmBottomAlert: Boolean(password !== passwordConfirm) })
        })
    }

    validateEmail = email => typeof email === 'string' && /\S+@\S+\.\S+/.test(email)

    sendVerifyCodeToEmail = async () => {
        const { lang } = this.props
        const { email } = this.state
        if (!this.validateEmail(email)) {
            return this.setState({
                isOneBtnDialogOpen: true,
                oneBtnDialogType: "checkEmail"
            })
        }

        try {
            await axios.post(`${GetBaseUrl()}/api/auth/certification`, {
                Email: email,
                lang
            })
            alert(`${i18n.t("onebtndialog.sendEmail.dialogBodyText1")} ${i18n.t("onebtndialog.sendEmail.dialogBodyText2")}`)
            this.setState({ verifyStatus: 'send' })
        }
        catch (e) {
            if (e && e.response && e.response.data && e.response.data.message) {
                const { message } = e.response.data
                
                if (message === 'Registered Email') {
                    this.setState({
                        isOneBtnDialogOpen: true,
                        oneBtnDialogType: "UsedEmail"
                    })
                }
                else if (message === 'withdraw') {
                    alert(i18n.t('signup.before.withdraw.24hour'))
                }
                else if (message.startsWith('duplicated=')) {
                    const arr = message.replace('duplicated=', '').split(',')
                    let str = i18n.t("web.signup.email.duplicated") + '\n'
                    arr.forEach(item => {
                        str += '\n - '
                        switch (item) {
                            case 'apple': str += i18n.t("web.apple.login"); break
                            case 'facebook': str += i18n.t("web.facebook.login"); break
                            case 'google': str += i18n.t("web.google.login"); break
                            case 'line': str += i18n.t("web.line.login"); break
                            case 'local': str += i18n.t("web.email.login"); break
                            case 'naver': str += i18n.t("web.naver.login"); break
                            default: break
                        }
                    })
                    alert(str)
                }
                else {
                    this.setState({
                        isOneBtnDialogOpen: true,
                        oneBtnDialogType: "signupError"
                    })
                }
            }
            else {
                this.setState({
                    isOneBtnDialogOpen: true,
                    oneBtnDialogType: "signupError"
                })
            }
        }
    }

    verifyCode = async () => {
        const { email, code } = this.state
        if (!code) return

        try {
            await axios.post(`${GetBaseUrl()}/api/auth/check_certification`, {
                key: code,
                Email: email,
            })
            this.setState({ verifyStatus: 'verified' })
        }
        catch (e) {
            this.setState({
                isOneBtnDialogOpen: true,
                oneBtnDialogType: "verifyNumber"
            })
        }
    }

    signUp = async () => {
        const { lang } = this.props
        const {
            emailAlertBottomText,
            nicknameAlertBottomText,
            passwordAlertBottomText,

            email,
            nickname,
            password,
            passwordConfirm,
            code,
            recommender,

            verifyStatus,

            isNoChildren,
            isTosAgree,
            isPrivacyAgree,
            isResaleAgree,
			isAiAgree,
            isUseInfoAgree,
            isMarketingAgree,
            isAccountPermanentAgree
        } = this.state

        if (
            emailAlertBottomText ||
            nicknameAlertBottomText ||
            passwordAlertBottomText ||

            !this.validateEmail(email) ||
            !nickname ||
            !password ||
            password !== passwordConfirm
        ) return

        if (!isNoChildren || !isTosAgree || !isPrivacyAgree || !isResaleAgree || !isAiAgree) {
            return this.setState({
                isOneBtnDialogOpen: true,
                oneBtnDialogType: "tosAgree"
            })
        }
        if (verifyStatus !== 'verified') {
            return this.setState({
                isOneBtnDialogOpen: true,
                oneBtnDialogType: "verifyNumber"
            })
        }
        SetTrackingData({ lang })

        try {
            await axios.post(`${GetBaseUrl()}/api/auth/signup`, {
                userName: nickname,
                displayName: nickname,
                Email: email,
                password,
                emailVerificationCode: code,    // ??
                optInfosAgreement: isUseInfoAgree,
                enableEmailNotifications: isMarketingAgree,
                activatePermanently: isAccountPermanentAgree,
                recommender,
                trackingData: GetTrackingData()
            })

            await Login(email, password)
            SetIsShowSignUpDialog(false)
            HistoryPush('/LoginAfterStep')

            if (mode === 'stage') {
                // ReactGA.event({
                //   category: 'user',
                //   action: 'signup'
                // })
                // ReactPixel.trackCustom("signup", {category: 'user',action: 'signup'})

                if (Array.isArray(window.dataLayer)) {
                    window.dataLayer.push({
                        event: 'tag_signup'
                    })
                }
            }
        }
        catch (e) {
            console.log(e)
            if (e && e.response) {
                if (e.response.data && e.response.data.message === 'withdraw') {
                    alert(i18n.t('signup.before.withdraw.24hour'))
                }
                else if (e.response.status === 409) {
                    this.setState({
                        isOneBtnDialogOpen: true,
                        oneBtnDialogType: "UsedEmail"
                    })
                }
                else {
                    this.setState({
                        isOneBtnDialogOpen: true,
                        oneBtnDialogType: "signupError"
                    })
                }
            }
            else {
                this.setState({
                    isOneBtnDialogOpen: true,
                    oneBtnDialogType: "signupError"
                })
            }
        }
    }

    renderVerifyStatus = () => {
        const { verifyStatus } = this.state
        switch (verifyStatus) {
            case 'send':
                return i18n.t("signup.confirm.auth.email.number")

            case 'verified':
                return i18n.t("signup.complete.auth.email.number")
            
            default:
                return i18n.t("signup.request.auth.email.number")
        }
    }

    render() {
        const { open, onClose, lang } = this.props
        const {
            isShowTosDialog,
            tosDialogContent,

            emailAlertBottomText,
            nicknameAlertBottomText,
            passwordAlertBottomText,
            isPasswordConfirmBottomAlert,

            email,
            nickname,
            password,
            passwordConfirm,
            code,
            recommender,

            verifyStatus,

            isNoChildren,
            isTosAgree,
            isPrivacyAgree,
            isResaleAgree,
			isAiAgree,
            isUseInfoAgree,
            isMarketingAgree,
            isAccountPermanentAgree,
            isAgreeAll,

            isOneBtnDialogOpen,
            oneBtnDialogType
        } = this.state

        return (
            <Dialog open={open} onClose={onClose} maxWidth="xl">
                <div className="signup-dialog-root-container">
                    <div className="close-btn" onClick={onClose}>
                        <CloseButton />
                    </div>
                    <div className="column-container1">
                        <img className="signup-dialog-logo" src="https://front.videomonster.com/images-7cuytg20/common/v2-logo.svg" alt="" />
                        <div className="form-container">
                            <div className="input-wrapper">
                                <InputField
                                    type="text"
                                    name="email"
                                    value={email}
                                    placeholder={i18n.t("global.email")}
                                    onChange={this.handleChangeInput}
                                    onBlur={this.handleBlurInput}
                                    maxLength={100}
                                    isShowBottomText={Boolean(emailAlertBottomText)}
                                    bottomText={emailAlertBottomText}
                                />
                            </div>
                            <div className="input-wrapper">
                                <InputField
                                    type="text"
                                    name="nickname"
                                    value={nickname}
                                    placeholder={i18n.t("global.nickname")}
                                    onChange={this.handleChangeInput}
                                    onBlur={this.handleBlurInput}
                                    maxLength={50}
                                    isShowBottomText={Boolean(nicknameAlertBottomText)}
                                    bottomText={nicknameAlertBottomText}
                                />
                            </div>
                            <div className="input-wrapper">
                                <InputField
                                    type="password"
                                    name="password"
                                    value={password}
                                    placeholder={i18n.t("global.password")}
                                    onChange={this.handleChangeInput}
                                    onBlur={this.handleBlurInput}
                                    maxLength={50}
                                    isShowBottomText={Boolean(passwordAlertBottomText)}
                                    bottomText={passwordAlertBottomText}
                                />
                            </div>
                            <div className="input-wrapper">
                                <InputField
                                    type="password"
                                    name="passwordConfirm"
                                    value={passwordConfirm}
                                    placeholder={i18n.t("signup.confirm.password")}
                                    onChange={this.handleChangePasswordConfirm}
                                    maxLength={50}
                                    isShowBottomText={isPasswordConfirmBottomAlert}
                                    bottomText={i18n.t("signup.check.password")}
                                />
                            </div>
                            <div className="input-wrapper">
                                <InputField
                                    type="text"
                                    name="code"
                                    value={code}
                                    placeholder={i18n.t("global.auth.number")}
                                    onChange={this.handleChangeInput}
                                    maxLength={10}
                                />
                                <div
                                    className="verify-button"
                                    onClick={() => {
                                        if (verifyStatus === 'none') this.sendVerifyCodeToEmail()
                                        else if (verifyStatus === 'send') this.verifyCode()
                                    }}
                                >
                                    {this.renderVerifyStatus()}
                                </div>
                            </div>
                            <div className="recommender-header">
                                {i18n.t("signup.enter.code.recomender")}
                            </div>
                            <div className="recommender-input-wrapper">
                                <InputField
                                    type="text"
                                    name="recommender"
                                    value={recommender}
                                    placeholder={i18n.t("signup.code.recomender")}
                                    onChange={this.handleChangeInput}
                                    maxLength={30}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="column-container2">
                        <div className="form-container">
                            <div className="checkbox-wrapper">
                                <Checkbox
                                    id="is-no-children"
                                    name="isNoChildren"
                                    checked={isNoChildren}
                                    label={i18n.t("signup.tos.checkbox2")}
                                    onChange={this.handleChangeCheckbox}
                                />
                            </div>
                            {
                                lang === 'ko'
                                    ?
                                    <>
                                        <div className="checkbox-wrapper">
                                            <Checkbox
                                                id="is-tos-agree"
                                                name="isTosAgree"
                                                checked={isTosAgree}
                                                label={this.koCheckboxLabel.label1}
                                                onChange={e => {
                                                    if (e.target.checked) this.setState({ isShowTosDialog: true, tosDialogContent: 'tos' })
                                                    this.handleChangeCheckbox(e)
                                                }}
                                            />
                                        </div>
                                        <div className="checkbox-wrapper">
                                            <Checkbox
                                                id="is-privacy-agree"
                                                name="isPrivacyAgree"
                                                checked={isPrivacyAgree}
                                                label={this.koCheckboxLabel.label2}
                                                onChange={e => {
                                                    if (e.target.checked) this.setState({ isShowTosDialog: true, tosDialogContent: 'privacy' })
                                                    this.handleChangeCheckbox(e)
                                                }}
                                            />
                                        </div>
                                        <div className="checkbox-wrapper">
                                            <Checkbox
                                                id="is-resale-agree"
                                                name="isResaleAgree"
                                                checked={isResaleAgree}
                                                label={this.koCheckboxLabel.label3}
                                                onChange={e => {
                                                    if (e.target.checked) this.setState({ isShowTosDialog: true, tosDialogContent: 'resale' })
                                                    this.handleChangeCheckbox(e)
                                                }}
                                            />
                                        </div>
										<div className="checkbox-wrapper">
                                            <Checkbox
                                                id="is-ai-agree"
                                                name="isAiAgree"
                                                checked={isAiAgree}
                                                label={this.koCheckboxLabel.label5}
                                                onChange={e => {
                                                    if (e.target.checked) this.setState({ isShowTosDialog: true, tosDialogContent: 'ai' })
                                                    this.handleChangeCheckbox(e)
                                                }}
                                            />
                                        </div>
                                        <div className="checkbox-wrapper">
                                            <Checkbox
                                                id="is-useinfo-agree"
                                                name="isUseInfoAgree"
                                                checked={isUseInfoAgree}
                                                label={this.koCheckboxLabel.label4}
                                                onChange={e => {
                                                    if (e.target.checked) this.setState({ isShowTosDialog: true, tosDialogContent: 'collect' })
                                                    this.handleChangeCheckbox(e)
                                                }}
                                            />
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="checkbox-wrapper">
                                            <Checkbox
                                                id="is-tos-agree"
                                                name="isTosAgree"
                                                checked={isTosAgree}
                                                label={i18n.t("signup.tos.checkbox3_1") + i18n.t("signup.tos.checkbox3_2")}
                                                onChange={e => {
                                                    if (e.target.checked) this.setState({ isShowTosDialog: true })
                                                    this.handleChangeCheckbox(e)
                                                }}
                                            />
                                        </div>
                                        <div className="privacy-contents">
                                            - {i18n.t("signup.tos.checkbox4")}
                                            <br />
                                            - {i18n.t("signup.tos.checkbox5")}
                                            <br />
                                            - {i18n.t("signup.tos.checkbox6")}
											<br />
											- {i18n.t("signup.tos.checkbox9")}
                                        </div>
                                    </>
                            }
                            <div className="checkbox-wrapper">
                                <Checkbox
                                    id="is-marketing-agree"
                                    name="isMarketingAgree"
                                    checked={isMarketingAgree}
                                    label={i18n.t("signup.tos.checkbox7")}
                                    onChange={this.handleChangeCheckbox}
                                />
                            </div>
                            <div className="checkbox-wrapper">
                                <Checkbox
                                    id="is-account-permanent-agree"
                                    name="isAccountPermanentAgree"
                                    checked={isAccountPermanentAgree}
                                    label={i18n.t("signup.tos.checkbox8")}
                                    onChange={this.handleChangeCheckbox}
                                />
                            </div>
                            <div className="checkbox-wrapper">
                                <Checkbox
                                    checkboxType="rounded"
                                    id="agree-all"
                                    name="isAgreeAll"
                                    checked={isAgreeAll}
                                    label={i18n.t("signup.tos.checkbox1")}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            const { isTosAgree } = this.state
                                            if (!isTosAgree || !isPrivacyAgree || !isResaleAgree || !isAiAgree || !isUseInfoAgree) this.setState({ isShowTosDialog: true })

                                            this.setState({
                                                isAgreeAll: true,
                                                isNoChildren: true,
                                                isTosAgree: true,
                                                isPrivacyAgree: true,
                                                isResaleAgree: true,
                                                isAiAgree: true,
                                                isUseInfoAgree: true,
                                                isMarketingAgree: true,
                                                isAccountPermanentAgree: true
                                            })
                                        }
                                        else {
                                            this.setState({
                                                isAgreeAll: false,
                                                isNoChildren: false,
                                                isTosAgree: false,
                                                isPrivacyAgree: false,
                                                isResaleAgree: false,
                                                isAiAgree: false,
                                                isUseInfoAgree: false,
                                                isMarketingAgree: false,
                                                isAccountPermanentAgree: false
                                            })
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="signup-button" onClick={this.signUp}>
                            {i18n.t("signup.agree.all.complete")}
                        </div>
                    </div>
                </div>
                <TosDialog
                    open={isShowTosDialog}
                    onClose={() => this.setState({ isShowTosDialog: false, tosDialogContent: null })}
                    tosDialogContent={tosDialogContent}
                />

                <OneBtnDialog
                    open={isOneBtnDialogOpen}
                    closeBtn={this.handleClickOneBtnDialogClose}
                    onButtonClick={this.handleClickOneBtnDialogClose}
                    dialogType={oneBtnDialogType}
                />
            </Dialog>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(LoginDialog)